import React from "react";

// Customizable Area Start
import {
  Box,
  BoxProps,
  Grid,
  Typography,
  Table,
  TableCell,
  TableRow,
  Paper,
  TableHead,
  TableBody,
  TableContainer,
  createStyles,
  withStyles,
  CircularProgress,
} from "@material-ui/core";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  Area,
  AreaChart,
  Cell,
} from "recharts";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
// Customizable Area End

import LandingPageController, { Props } from "./LandingPageController";

export class LandingPageBlock extends LandingPageController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start

  showList = (taskList: any, index: any) => {
    return (
      <div>
        {taskList.isEmpty ? null :
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center", // Centers vertically
              alignItems: "center",     // Ce
            }}
          >
            <Typography display="block" style={{ color: this.taskListFontColor(taskList), fontWeight: 600 }}>
              TL {index + 1}
            </Typography>
            <br />
            <Typography display="block" style={{ color: this.taskListFontColor(taskList), fontSize: "14px" }}>
              {this.taskListSubmitted(taskList)}
            </Typography>
          </Box>

        }
      </div>
    )
  }


  showRating = (rating: number) => {
    return (
      <div style={{ display: "inline-block" }}>
        {[...Array(5).keys()].map((iter) =>
          iter < rating ? (
            <StarIcon
              key={iter}
              style={{ color: "#A046FB" }}
            />
          ) : (
            <StarBorderIcon
              key={iter}
              style={{ color: "gray" }}
            />
          )
        )}
      </div>
    )
  }
  // Customizable Area End

  render() {
    // Customizable Area Start
    const BoxView = Box as React.FC<BoxProps>;

    const barColors = ["#A046FB", "#361854", "#D93827", ""];

    return (
      <>
        <p id="topScroll" style={{ position: "absolute", top: "-100", left: "0", width: "100px", height: "100px" }} >Hello</p>
        {this.state.flag === 0 && (
          <Grid container>
            <Grid xs={12} lg={12} item>
              <BoxView className={this.props.classes.subGrid}>
                <Typography className={this.props.classes.mainPatients}>
                  {this.state.languageSwitch.Patients}
                </Typography>
                <Typography className={this.props.classes.subText}>
                  {this.state.languageSwitch.patientDescription}
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={4} lg={3}>
                    <BoxView className={this.props.classes.listItemone} style={{ marginLeft: "0", width: "100%" }}>
                      <BoxView className={this.props.classes.listbox}>
                        <Typography id="totalPatients" className={this.props.classes.total}>
                          {this.state.totalPatients}
                        </Typography>
                        <Typography className={this.props.classes.totalPatients}>
                          {this.state.languageSwitch.TotalPatients}
                        </Typography>
                        <Typography className={this.props.classes.totalPatientsDes}>
                          {this.state.languageSwitch.TotalPatientDes}
                        </Typography>
                      </BoxView>
                    </BoxView>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4} lg={3}>
                    <BoxView className={this.props.classes.listItemtwo} style={{ marginLeft: "0", width: "100%" }}>
                      <BoxView className={this.props.classes.listbox}>
                        <Typography className={this.props.classes.total}>
                          {this.state.activePatients}
                        </Typography>
                        <Typography className={this.props.classes.totalPatients}>
                          {this.state.languageSwitch.ActivePatients}
                        </Typography>
                        <Typography className={this.props.classes.totalPatientsDes}>
                          {this.state.languageSwitch.PatientDes}
                        </Typography>
                      </BoxView>
                    </BoxView>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4} lg={3}>
                    <BoxView className={this.props.classes.listItemthree} style={{ marginLeft: "0", width: "100%" }}>
                      <BoxView className={this.props.classes.listbox}>
                        <Typography className={this.props.classes.total}>
                          {this.state.inActivePatients}
                        </Typography>
                        <Typography className={this.props.classes.totalPatients}>
                          {this.state.languageSwitch.InactivePatients}
                        </Typography>
                        <Typography className={this.props.classes.totalPatientsDes}>
                          {this.state.languageSwitch.InactivePatientDes}
                        </Typography>
                      </BoxView>
                    </BoxView>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4} lg={3}>
                    <BoxView className={this.props.classes.listItemthree} style={{ marginLeft: "0", width: "100%" }}>
                      <BoxView className={this.props.classes.listbox}>
                        <Typography className={this.props.classes.total}>
                          {this.state.completedMilestone}
                        </Typography>
                        <Typography className={this.props.classes.totalPatients}>
                          {this.state.languageSwitch.Completed}
                        </Typography>
                        <Typography className={this.props.classes.totalPatientsDes}>
                          {this.state.languageSwitch.CompletedDes}
                        </Typography>
                      </BoxView>
                    </BoxView>
                  </Grid>
                </Grid>
                <Grid container spacing={3} className={this.props.classes.listitem}>
                  <BoxView
                    className={this.props.classes.chartBoxWrap}
                  >
                    <Grid container spacing={4}>
                      <Grid item
                        xs={12}
                        sm={4}
                        md={6}
                        lg={6}
                      >
                        <BoxView style={{ flexBasis: "45%" }}>
                          <BoxView className={this.props.classes.chartTextWrap}>
                            <Typography className={this.props.classes.chartText}>
                              {this.state.languageSwitch.MilestoneStatistics}
                            </Typography>
                            <BoxView className={this.props.classes.chartBoxBar}>
                              <ResponsiveContainer width={400} height={400} style={{ marginRight: '10%' }}>
                                <BarChart data={this.state.milestonesBarChart}>
                                  <CartesianGrid strokeDasharray="3" />
                                  <XAxis
                                    data-test-id='mileXAxis'
                                    dataKey="name"
                                    tickFormatter={this.textSubstring}
                                    style={{
                                      fontFamily: "Jost",
                                      fontWeight: "400",
                                      fontSize: "12px",
                                    }}
                                  />
                                  <YAxis
                                    domain={[0, this.state.averageMilestonesBarChart]}
                                    ticks={this.state.milestoneBarTicks}
                                    style={{
                                      fontFamily: "Jost",
                                      fontWeight: "400",
                                      fontSize: "14px",
                                    }}
                                  />
                                  <Tooltip />
                                  <Bar dataKey="uv" fill="#A046FB" barSize={30}>
                                    {this.state.milestonesBarChart.map((entry, index) => (
                                      <Cell
                                        key={`cell-${index}`}
                                        fill={barColors[index % 20]}
                                      />
                                    ))}
                                  </Bar>
                                </BarChart>
                              </ResponsiveContainer>
                            </BoxView>
                          </BoxView>
                        </BoxView>
                      </Grid>
                      <Grid item
                        lg={6}
                        sm={4}
                        xs={12}
                        md={6}
                      >
                        <BoxView style={{ flexBasis: "45%" }}>
                          {this.state.averageFeedBack.length > 0 ?
                            <BoxView className={this.props.classes.chartTextWrap}>
                              <Typography className={this.props.classes.chartText}>
                                {this.state.languageSwitch.AverageFeedback}
                              </Typography>
                              <BoxView className={this.props.classes.chartBoxBar}>
                                <div style={{ overflowX: 'auto', maxWidth: this.state.averageFeedBack.length > 4 ? '400px' : '450px' }}>
                                  <ResponsiveContainer width={450} height={400}>
                                    <AreaChart
                                      width={730}
                                      height={250}
                                      data={this.state.averageFeedBack}
                                      margin={{ top: 10, right: 30, left: 10, bottom: 0 }}
                                    >
                                      <defs>
                                        <linearGradient
                                          id="colorUv"
                                          x1="0"
                                          y1="0"
                                          x2="0"
                                          y2="1"
                                        >
                                          <stop
                                            offset="5%"
                                            stopColor="#A046FB"
                                            stopOpacity={0.8}
                                          />
                                          <stop
                                            offset="95%"
                                            stopColor="#A046FB"
                                            stopOpacity={0}
                                          />
                                        </linearGradient>
                                        <linearGradient
                                          id="colorPv"
                                          x1="0"
                                          y1="0"
                                          x2="0"
                                          y2="1"
                                        >
                                          <stop
                                            offset="5%"
                                            stopColor="#000000"
                                            stopOpacity={0.8}
                                          />
                                          <stop
                                            offset="95%"
                                            stopColor="#000000"
                                            stopOpacity={0}
                                          />
                                        </linearGradient>
                                      </defs>
                                      <XAxis
                                        dataKey="name"
                                        style={{
                                          fontFamily: "Jost",
                                          fontWeight: "400",
                                          fontSize: "10px",
                                        }}
                                      />
                                      <YAxis
                                        domain={[0, 5]}
                                        ticks={[0, 1, 2, 3, 4, 5]}
                                        style={{
                                          fontFamily: "Jost",
                                          fontWeight: "400",
                                          fontSize: "14px",
                                        }}
                                      />
                                      <CartesianGrid strokeDasharray="3 3" />
                                      <Tooltip />
                                      <Area
                                        type="monotone"
                                        dataKey="uv"
                                        stroke="#A046FB"
                                        fillOpacity={1}
                                        strokeWidth={2}
                                        fill="url(#colorUv)"
                                      />
                                    </AreaChart>

                                  </ResponsiveContainer>
                                </div>
                              </BoxView>
                            </BoxView>
                            :
                            <BoxView className={this.props.classes.chartTextWrapCircle}>
                              <Typography className={this.props.classes.chartText}>
                                {this.state.languageSwitch.AverageFeedback}
                              </Typography>
                              <BoxView className={this.props.classes.chartTaskBox}>
                                {this.state.languageSwitch.FeedbackNotAvailable}
                              </BoxView>
                            </BoxView>}
                        </BoxView>
                      </Grid>
                    </Grid>
                  </BoxView>
                  <BoxView
                    className={this.props.classes.chartBoxWrap}
                  >
                    <Grid container spacing={4}>
                      <Grid item
                        xs={12}
                        sm={4}
                        lg={6}
                        md={6}
                      >
                        <BoxView>
                          <BoxView className={this.props.classes.chartTextWrap}>
                            <Typography className={this.props.classes.chartText}>
                              {this.state.languageSwitch.TaskStatistics}
                            </Typography>
                            <BoxView className={this.props.classes.chartBoxBar}>
                              <ResponsiveContainer width={400} height={400} style={{ marginRight: '10%' }}>
                                <BarChart data={this.state.taskStatisticsData}>
                                  <CartesianGrid strokeDasharray="3" />
                                  <XAxis
                                    data-test-id='taskXAxis'
                                    dataKey="name"
                                    tickFormatter={this.textSubstring}
                                    style={{
                                      fontFamily: "Jost",
                                      fontWeight: "400",
                                      fontSize: "12px",
                                    }}
                                  />
                                  <YAxis
                                    domain={[0, this.state.averageTaskBarChart]}
                                    ticks={this.state.taskBarTicks}
                                    style={{
                                      fontFamily: "Jost",
                                      fontWeight: "400",
                                      fontSize: "14px",
                                    }}
                                  />
                                  <Tooltip />
                                  <Bar dataKey="uv" fill="#A046FB" barSize={30}>
                                    {this.state.taskStatisticsData.map((entry, index) => (
                                      <Cell
                                        key={`cell-${index}`}
                                        fill={barColors[index % 20]}
                                      />
                                    ))}
                                  </Bar>
                                </BarChart>
                              </ResponsiveContainer>
                            </BoxView>
                          </BoxView>
                        </BoxView>
                      </Grid>
                      <Grid item
                        xs={12}
                        md={6}
                        sm={4}
                        lg={6}
                      >
                        <BoxView>
                          <BoxView className={this.props.classes.chartTextWrapCircle}>
                            <Typography className={this.props.classes.chartTextCircular}>
                              {this.state.languageSwitch.Milestone}
                            </Typography>
                            <BoxView
                              style={{ position: "relative" }}
                              className={this.props.classes.chartBoxCicular}
                            >
                              <Box
                                width={250}
                                position="relative"
                                height={250}
                                style={{ left: "22%", top: "22%" }}
                              >
                                <CircularProgress
                                  variant="determinate"
                                  size={250}
                                  value={100}
                                  thickness={4}
                                  style={{
                                    color: "#E7E7E7",
                                    zIndex: "0",
                                    position: "absolute",
                                  }}
                                />
                                <CircularProgress
                                  variant="determinate"
                                  size={250}
                                  value={(this.state.completedMilestones / this.state.totalMilestones) * 100}
                                  thickness={4}
                                  style={{ zIndex: "1", color: "#A046FB" }}
                                />
                                <Box
                                  position="absolute"
                                  top="30%"
                                  display="flex"
                                  left="30%"
                                  alignItems="center"
                                  flexDirection="column"
                                  justifyContent="center"
                                  zIndex={3}
                                >
                                  <Typography
                                    variant="caption"
                                    id="completedMilestones"
                                    style={{
                                      color: "#A046FB",
                                      fontFamily: "Jost",
                                      fontSize: "40px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    {this.state.completedMilestones}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    style={{
                                      color: "#5A5A5A",
                                      fontWeight: "400",
                                      fontFamily: "Jost",
                                      fontSize: "20px",
                                    }}
                                  >
                                    {this.state.languageSwitch.Completed}
                                  </Typography>
                                </Box>
                              </Box>
                              <Box
                                position="absolute"
                                width="100%"
                                bottom="10%"
                                textAlign="center"
                              >
                                <Box
                                  width="100%"
                                  justifyContent="space-around"
                                  display="flex"
                                  alignItems="center"
                                >
                                  <Box display="flex" alignItems="center">
                                    <div
                                      style={{
                                        width: "12px",
                                        height: "12px",
                                        backgroundColor: "#E7E7E7",
                                        borderRadius: "50%",
                                        marginRight: "5px",
                                      }}
                                    />
                                    <Typography
                                      variant="caption"
                                      id="totalMilestones"
                                      style={{
                                        color: "#5A5A5A",
                                        fontWeight: "400",
                                        fontFamily: "Jost",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {this.state.languageSwitch.TotalMilestones}: {this.state.totalMilestones}
                                    </Typography>
                                  </Box>
                                  <Box alignItems="center" display="flex">
                                    <div
                                      style={{
                                        width: "12px",
                                        borderRadius: "50%",
                                        height: "12px",
                                        backgroundColor: "#A046FB",
                                        marginRight: "5px",
                                      }}
                                    />
                                    <Typography
                                      variant="caption"
                                      style={{
                                        color: "#5A5A5A",
                                        fontWeight: "400",
                                        fontFamily: "Jost",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {this.state.languageSwitch.CompletedMilestones}: {this.state.completedMilestones}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            </BoxView>
                          </BoxView>
                        </BoxView>
                      </Grid>
                    </Grid>
                  </BoxView>
                  <BoxView className={this.props.classes.chartTextWrap} style={{ marginTop: "25px" }}>
                    <Typography className={this.props.classes.chartText}>
                      {this.state.languageSwitch.RecentlyAdded}
                    </Typography>
                    <TableContainer
                      component={Paper}
                      className={this.props.classes.table}
                    >
                      {this.state.patientTableData.length > 0 ? <Table aria-label="customized table">
                        <TableHead>
                          <TableRow className={this.props.classes.tableRow}>
                            <TableCell
                              align="left"
                              className={this.props.classes.tableCell}
                            >
                              {this.state.languageSwitch.SrNo}
                            </TableCell>
                            <TableCell
                              align="center"
                              className={this.props.classes.tableCell}
                            >
                              {this.state.languageSwitch.PatientID}
                            </TableCell>
                            <TableCell align="right" />
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.patientTableData.map((rows, indexing) => {
                            console.log(rows, "rows@@@")
                            return (
                              <TableRow
                                key={rows.srNo}
                                className={
                                  indexing % 2 === 0 ? "" : this.props.classes.tableBody
                                }
                              >
                                <TableCell
                                  scope="row"
                                  className={this.props.classes.tableCell2}
                                >
                                  {rows.srNo}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className={this.props.classes.tableCell2}
                                >
                                  {rows.patientId}{" "}
                                  {!rows.adminActivated && (
                                    <span style={{ color: "#F4300B", fontWeight: 400 }}>
                                      (Inactive)
                                    </span>
                                  )}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  id="reports"
                                  className={`${this.props.classes.reports} clickable`}
                                  onClick={() => this.handleFlagChangeId(rows)}
                                >
                                  <span style={{ cursor: "pointer" }}>
                                    {rows.report}
                                  </span>
                                </TableCell>
                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table> : <Typography id="Nodatafound" className={this.props.classes.Nodatafoundtext}>
                        {this.state.languageSwitch.NoPatientsFound}
                      </Typography>}
                    </TableContainer>
                  </BoxView>
                </Grid>
              </BoxView>
            </Grid>
          </Grid>
        )}
        {this.state.flag === 1 && (
          <Grid container>
            <Grid xs={12} lg={12} item>
              <BoxView className={this.props.classes.subGrid}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", width: '75%' }}>
                  <Typography className={this.props.classes.mainPatients}>
                    Report
                  </Typography>
                  <div onClick={this.handleNewFlagChange} style={{ background: "white" }}>
                    <button style={{ width: "85px", border: "2px solid #A046FB", borderRadius: "10px", alignItems: "center", display: "flex", padding: "8px", justifyContent: "space-between", cursor: "pointer" }}>
                      <KeyboardBackspaceIcon style={{ color: "#A046FB", cursor: "pointer" }} />
                      <Typography className={this.props.classes.subText} style={{ fontWeight: "bold" }}>
                        {this.state.languageSwitch.Back}
                      </Typography>
                    </button>
                  </div>
                </div>
                <Typography className={this.props.classes.subText}>
                  {this.state.languageSwitch.patientReportPageDescription}
                </Typography>
                <Grid className={this.props.classes.listitem} lg={10}>
                  <BoxView className={this.props.classes.listItemBoxWrap}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <BoxView className={this.props.classes.listItemone} style={{ width: "100%" }}>
                          <BoxView className={this.props.classes.listbox}>
                            <Typography className={this.props.classes.total} id="patientIdName">
                              {this.state.patientID}
                            </Typography>

                            <Typography className={this.props.classes.totalPatients}>
                              {this.state.languageSwitch.PatientID}
                            </Typography>
                            {this.state.singlePatientData?.account_deactivated === false && (
                              <Typography
                                style={{
                                  color: "#FFFFFF",
                                  fontSize: "20px",
                                  marginTop: "4px",
                                  fontWeight: 700,
                                }}
                              >
                                (Inactive)
                              </Typography>
                            )}
                          </BoxView>
                        </BoxView>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <BoxView className={this.props.classes.listItemtwo} style={{ width: "100%" }}>
                          <BoxView className={this.props.classes.listbox}>
                            <Typography className={this.props.classes.total}>
                              {this.state.singlePatientData.site_number}
                            </Typography>
                            <Typography className={this.props.classes.totalPatients}>
                              {this.state.languageSwitch.Site_ID}
                            </Typography>
                          </BoxView>
                        </BoxView>
                      </Grid>
                      {/* <Grid item xs={12} sm={4} md={4} lg={4}>
                        <BoxView className={this.props.classes.listItemthree} style={{ width: "100%" }}>
                          <BoxView className={this.props.classes.listbox}>
                            <Typography id="siteCoordinatorName" className={this.props.classes.total}>
                              {this.state.singlePatientData.site_coordinator_account_full_name}
                            </Typography>
                            <Typography className={this.props.classes.totalPatients}>
                              {this.state.languageSwitch.Site_Coordinator}
                            </Typography>
                          </BoxView>
                        </BoxView>
                      </Grid> */}
                    </Grid>
                  </BoxView>
                  <BoxView
                    className={this.props.classes.chartBoxWrap}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      width: "100%", maxWidth: "100%"
                    }}
                  >
                    <Grid container spacing={4}>
                      <Grid item
                        sm={4}
                        xs={12}
                        md={6}
                        lg={6}
                      >
                        <BoxView>
                          <BoxView className={this.props.classes.chartTextWrap}>
                            <Typography className={this.props.classes.chartText}>
                              {this.state.languageSwitch.PointsEarned}
                            </Typography>
                            <BoxView
                              style={{ position: "relative" }}
                              className={this.props.classes.chartBox}
                            >
                              <Box
                                position="relative"
                                height={250}
                                width={250}
                                style={{ top: "22%", left: "22%" }}
                              >
                                <CircularProgress
                                  variant="determinate"
                                  value={100}
                                  thickness={4}
                                  size={250}
                                  style={{
                                    zIndex: "0",
                                    color: "#E7E7E7",
                                    position: "absolute",
                                  }}
                                />
                                <CircularProgress
                                  variant="determinate"
                                  thickness={4}
                                  value={(this.state.rewardsPoints.points_earned.earned_points / this.state.rewardsPoints.points_earned.total_point) * 100}
                                  size={250}
                                  style={{ zIndex: "1", color: "#A046FB" }}
                                />
                                <Box
                                  position="absolute"
                                  left="35%"
                                  justifyContent="center"
                                  top="30%"
                                  display="flex"
                                  flexDirection="column"
                                  alignItems="center"
                                  zIndex={3}
                                >
                                  <Typography
                                    variant="caption"
                                    style={{
                                      color: "#A046FB",
                                      fontWeight: "700",
                                      fontFamily: "Jost",
                                      fontSize: "40px",
                                    }}
                                  >
                                    {this.state.rewardsPoints.points_earned.earned_points}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    style={{
                                      color: "#5A5A5A",
                                      fontWeight: "400",
                                      fontFamily: "Jost",
                                      fontSize: "20px",
                                    }}
                                  >
                                    {this.state.languageSwitch.Earned}
                                  </Typography>
                                </Box>
                              </Box>
                              <Box
                                position="absolute"
                                width="100%"
                                textAlign="center"
                                bottom="10%"
                              >
                                <Box
                                  width="100%"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="space-around"
                                >
                                  <Box alignItems="center" display="flex">
                                    <div
                                      style={{
                                        width: "12px",
                                        borderRadius: "50%",
                                        height: "12px",
                                        backgroundColor: "#E7E7E7",
                                        marginRight: "5px",
                                      }}
                                    />
                                    <Typography
                                      variant="caption"
                                      style={{
                                        color: "#5A5A5A",
                                        fontWeight: "400",
                                        fontFamily: "Jost",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {this.state.languageSwitch.TotalPoints}: {this.state.rewardsPoints.points_earned.total_point}
                                    </Typography>
                                  </Box>
                                  <Box alignItems="center" display="flex">
                                    <div
                                      style={{
                                        width: "12px",
                                        height: "12px",
                                        borderRadius: "50%",
                                        marginRight: "5px",
                                        backgroundColor: "#A046FB",
                                      }}
                                    />
                                    <Typography
                                      variant="caption"
                                      style={{
                                        color: "#5A5A5A",
                                        fontWeight: "400",
                                        fontFamily: "Jost",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {this.state.languageSwitch.EarnedPoints}: {this.state.rewardsPoints.points_earned.earned_points}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            </BoxView>
                          </BoxView>
                        </BoxView>
                      </Grid>
                      <Grid item
                        sm={4}
                        md={6}
                        lg={6}
                      >
                        <BoxView>
                          <BoxView className={this.props.classes.chartTextWrap}>
                            <Typography className={this.props.classes.chartText}>
                              {this.state.languageSwitch.RewardsEarned}
                            </Typography>
                            <BoxView
                              style={{ position: "relative" }}
                              className={this.props.classes.chartBox}
                            >
                              <Box
                                position="relative"
                                width={250}
                                height={250}
                                style={{ left: "22%", top: "22%" }}
                              >
                                <CircularProgress
                                  variant="determinate"
                                  value={100}
                                  size={250}
                                  thickness={4}
                                  style={{
                                    color: "#E7E7E7",
                                    position: "absolute",
                                    zIndex: "0",
                                  }}
                                />
                                <CircularProgress
                                  variant="determinate"
                                  thickness={4}
                                  value={this.rewardGraphValue()}
                                  size={250}
                                  style={{ zIndex: "1", color: "#A046FB" }}
                                />
                                <Box
                                  position="absolute"
                                  left="31%"
                                  top="28%"
                                  display="flex"
                                  flexDirection="column"
                                  justifyContent="center"
                                  alignItems="center"
                                  zIndex={3}
                                >
                                  <Typography
                                    variant="caption"
                                    style={{
                                      color: "#A046FB",
                                      fontFamily: "Jost",
                                      fontSize: "40px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    {this.state.rewardsPoints.rewards_points.total_redeem}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    style={{
                                      color: "#5A5A5A",
                                      fontWeight: "400",
                                      fontFamily: "Jost",
                                      fontSize: "20px",
                                    }}
                                  >
                                    {this.state.languageSwitch.Redeemed}
                                  </Typography>
                                </Box>
                              </Box>
                              <Box
                                position="absolute"
                                bottom="10%"
                                textAlign="center"
                                width="100%"
                              >
                                <Box
                                  width="100%"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="space-around"
                                >
                                  <Box display="flex" alignItems="center">
                                    <div
                                      style={{
                                        width: "12px",
                                        height: "12px",
                                        backgroundColor: "#E7E7E7",
                                        borderRadius: "50%",
                                        marginRight: "5px",
                                      }}
                                    />
                                    <Typography
                                      variant="caption"
                                      style={{
                                        color: "#5A5A5A",
                                        fontWeight: "400",
                                        fontFamily: "Jost",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {this.state.languageSwitch.TotalEarned}: {this.state.rewardsPoints.rewards_points.total_earn}
                                    </Typography>
                                  </Box>
                                  <Box display="flex" alignItems="center">
                                    <div
                                      style={{
                                        width: "12px",
                                        height: "12px",
                                        borderRadius: "50%",
                                        backgroundColor: "#A046FB",
                                        marginRight: "5px",
                                      }}
                                    />
                                    <Typography
                                      variant="caption"
                                      style={{
                                        color: "#5A5A5A",
                                        fontFamily: "Jost",
                                        fontWeight: "400",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {this.state.languageSwitch.TotalRedeemed}: {this.state.rewardsPoints.rewards_points.total_redeem}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            </BoxView>
                          </BoxView>
                        </BoxView>
                      </Grid>
                    </Grid>
                  </BoxView>

                  <BoxView className={this.props.classes.chartBoxWrap} style={{ width: "100%", maxWidth: "100%" }}>
                    <Grid container spacing={4}>
                      <Grid
                        item
                        md={6}
                        xs={12}
                        lg={6}
                        sm={4}
                      >
                        <BoxView className={this.props.classes.chartTextWrap}>
                          <Typography className={this.props.classes.chartText}>
                            {this.state.languageSwitch.TaskList}
                          </Typography>
                          <BoxView
                            className={this.props.classes.chartBox}
                            style={{ position: "relative" }}
                          >
                            <Box
                              position="relative"
                              height={250}
                              width={250}
                              style={{ left: "22%", top: "22%" }}
                            >
                              <CircularProgress
                                variant="determinate"
                                size={250}
                                value={100}
                                thickness={4}
                                style={{
                                  color: "#E7E7E7",
                                  zIndex: "0",
                                  position: "absolute",
                                }}
                              />
                              <CircularProgress
                                variant="determinate"
                                size={250}
                                value={this.taskListAttended()}
                                thickness={4}
                                style={{ color: "#A046FB", zIndex: "1" }}
                              />
                              <Box
                                position="absolute"
                                left="35%"
                                top="30%"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                flexDirection="column"
                                zIndex={3}
                              >
                                <Typography
                                  variant="caption"
                                  style={{
                                    color: "#A046FB",
                                    fontWeight: "700",
                                    fontFamily: "Jost",
                                    fontSize: "40px",
                                  }}
                                >
                                  {this.state.singlePatientData.task_list.task_attended}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  style={{
                                    color: "#5A5A5A",
                                    fontFamily: "Jost",
                                    fontWeight: "400",
                                    fontSize: "20px",
                                  }}
                                >
                                  {this.state.languageSwitch.Attended}
                                </Typography>
                              </Box>
                            </Box>
                            <Box
                              position="absolute"
                              width="100%"
                              bottom="10%"
                              textAlign="center"
                            >
                              <Box
                                width="100%"
                                justifyContent="space-around"
                                display="flex"
                                alignItems="center"
                              >
                                <Box alignItems="center" display="flex">
                                  <div
                                    style={{
                                      width: "12px",
                                      height: "12px",
                                      backgroundColor: "#E7E7E7",
                                      borderRadius: "50%",
                                      marginRight: "5px",
                                    }}
                                  />
                                  <Typography
                                    variant="caption"
                                    style={{
                                      color: "#5A5A5A",
                                      fontWeight: "400",
                                      fontFamily: "Jost",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {this.state.languageSwitch.TaskAssigned}: {this.state.singlePatientData.task_list.task_assigned_point}
                                  </Typography>
                                </Box>
                                <Box display="flex" alignItems="center">
                                  <div
                                    style={{
                                      width: "12px",
                                      height: "12px",
                                      borderRadius: "50%",
                                      backgroundColor: "#A046FB",
                                      marginRight: "5px",
                                    }}
                                  />
                                  <Typography
                                    variant="caption"
                                    style={{
                                      color: "#5A5A5A",
                                      fontFamily: "Jost",
                                      fontWeight: "400",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {this.state.languageSwitch.TaskAttended}: {this.state.singlePatientData.task_list.task_attended}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </BoxView>
                        </BoxView>
                      </Grid>
                      <Grid
                        xs={12}
                        item
                        sm={4}
                        lg={6}
                        md={6}
                      >
                        <BoxView className={this.props.classes.chartTextWrap}>
                          <Typography className={this.props.classes.chartText}>
                            {this.state.languageSwitch.TaskListInformation}
                          </Typography>
                          <BoxView className={this.props.classes.chartBox} style={{ overflowY: "scroll" }} sx={{ border: '1px solid #ccc', borderRadius: 6 }}>
                            {
                              this.state.taskListInformation.length == 0 ?
                                <Box
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "inherit"
                                  }}
                                >
                                  <Typography>{this.state.languageSwitch.NoDataFound}</Typography>
                                </Box>
                                :

                                <Grid container >
                                  {this.state.taskListInformation.map((taskList: any, index: number) => (
                                    <Grid item xs={12} md={3} key={index}>
                                      <Box
                                        sx={{
                                          height: '85px',
                                          bgcolor: this.taskListBgColor(taskList),
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          borderRadius: 1,
                                          border: '1px solid #dddddd',
                                        }}
                                        style={{
                                          borderCollapse: "collapse"
                                        }}
                                      >
                                        {this.showList(taskList, index)}
                                      </Box>
                                    </Grid>
                                  ))}
                                </Grid>
                            }
                          </BoxView>

                        </BoxView>
                      </Grid>
                    </Grid>
                  </BoxView>
                  <BoxView className={this.props.classes.chartBoxWrap} style={{ width: "100%", maxWidth: "100%" }}>
                    <Grid container spacing={4}>
                      <Grid item
                        xs={12}
                        md={6}
                        lg={6}
                        sm={4}
                      >
                        <BoxView className={this.props.classes.chartTextWrap}>
                          <Typography className={this.props.classes.chartText}>
                            {this.state.languageSwitch.Milestone}
                          </Typography>
                          <BoxView
                            style={{ position: "relative" }}
                            className={this.props.classes.chartBox}
                          >
                            <Box
                              position="relative"
                              height={250}
                              width={250}
                              style={{ left: "22%", top: "22%" }}
                            >
                              <CircularProgress
                                variant="determinate"
                                size={250}
                                value={100}
                                thickness={4}
                                style={{
                                  color: "#E7E7E7",
                                  zIndex: "0",
                                  position: "absolute",
                                }}
                              />
                              <CircularProgress
                                variant="determinate"
                                value={(this.state.completedMilestones / this.state.totalMilestones) * 100}
                                thickness={4}
                                size={250}
                                style={{ color: "#A046FB", zIndex: "1" }}
                              />
                              <Box
                                position="absolute"
                                top="30%"
                                left="30%"
                                alignItems="center"
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                                zIndex={3}
                              >
                                <Typography
                                  variant="caption"
                                  style={{
                                    color: "#A046FB",
                                    fontWeight: "700",
                                    fontFamily: "Jost",
                                    fontSize: "40px",
                                  }}
                                >
                                  {this.state.singlePatientData.milestone_managements.completed_milestones}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  style={{
                                    color: "#5A5A5A",
                                    fontWeight: "400",
                                    fontFamily: "Jost",
                                    fontSize: "20px",
                                  }}
                                >
                                  {this.state.languageSwitch.Completed}
                                </Typography>
                              </Box>
                            </Box>
                            <Box
                              position="absolute"
                              width="100%"
                              bottom="10%"
                              textAlign="center"
                            >
                              <Box
                                width="100%"
                                display="flex"
                                alignItems="center"
                                justifyContent="space-around"
                              >
                                <Box display="flex" alignItems="center">
                                  <div
                                    style={{
                                      width: "12px",
                                      height: "12px",
                                      backgroundColor: "#E7E7E7",
                                      borderRadius: "50%",
                                      marginRight: "5px",
                                    }}
                                  />
                                  <Typography
                                    variant="caption"
                                    style={{
                                      color: "#5A5A5A",
                                      fontFamily: "Jost",
                                      fontSize: "14px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {this.state.languageSwitch.TotalMilestones}: {this.state.singlePatientData.milestone_managements.total_milestones}
                                  </Typography>
                                </Box>
                                <Box display="flex" alignItems="center">
                                  <div
                                    style={{
                                      width: "12px",
                                      height: "12px",
                                      backgroundColor: "#A046FB",
                                      borderRadius: "50%",
                                      marginRight: "5px",
                                    }}
                                  />
                                  <Typography
                                    variant="caption"
                                    style={{
                                      color: "#5A5A5A",
                                      fontFamily: "Jost",
                                      fontSize: "14px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {this.state.languageSwitch.CompletedMilestones}: {this.state.singlePatientData.milestone_managements.completed_milestones}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </BoxView>
                        </BoxView>
                      </Grid>
                      <Grid item
                        xs={12}
                        md={6}
                        lg={6}
                        sm={4}
                      >
                        <BoxView className={this.props.classes.chartTextWrap}>
                          <Typography className={this.props.classes.chartText}>
                            {this.state.languageSwitch.VisitSchedule}
                          </Typography>
                          <BoxView className={this.props.classes.chartBoxBar}>
                            <ResponsiveContainer width={400} height={400}>
                              <BarChart data={this.state.visitScheduleData} margin={{ top: 20, right: 20, bottom: 20 }}>
                                <CartesianGrid vertical={false} stroke="#8884d8" strokeDasharray="3" />
                                <XAxis
                                  dataKey="name"
                                  style={{
                                    fontFamily: "Jost",
                                    fontWeight: "400",
                                    fontSize: "14px",
                                  }}
                                />
                                <YAxis
                                  axisLine={false}
                                  domain={[0, 100]}
                                  style={{
                                    fontFamily: "Jost",
                                    fontWeight: "400",
                                    fontSize: "14px",
                                  }}
                                />
                                <Tooltip />
                                <Bar
                                  id="bardata"
                                  dataKey="uv"
                                  fill="#A046FB"
                                  barSize={30}
                                >
                                  {this.state.visitScheduleData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill="#A046FB" />
                                  ))}
                                </Bar>
                              </BarChart>
                            </ResponsiveContainer>
                          </BoxView>
                        </BoxView>
                      </Grid>
                    </Grid>
                  </BoxView>
                  <BoxView className={this.props.classes.chartTextWrap} style={{ marginTop: "25px" }}>
                    <Typography className={this.props.classes.chartText}>
                      {this.state.languageSwitch.Feedback}
                    </Typography>
                    <TableContainer
                      component={Paper}
                      className={this.props.classes.table}
                    >
                      {this.state.taskFeedbackPatient.length > 0 ?
                        <Table aria-label="customized table">
                          <TableHead>
                            <TableRow className={this.props.classes.tableRow}>
                              <TableCell
                                align="left"
                                className={this.props.classes.tableCell}
                              >
                                {this.state.languageSwitch.SrNo}
                              </TableCell>
                              <TableCell
                                align="center"
                                className={this.props.classes.tableCell}
                              >
                                {this.state.languageSwitch.DateTime}
                              </TableCell>
                              <TableCell
                                align="center"
                                className={this.props.classes.tableCell}
                              >
                                {this.state.languageSwitch.Rating}
                              </TableCell>
                              <TableCell
                                align="center"
                                className={this.props.classes.tableCell}
                              >
                                {this.state.languageSwitch.Remarks}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.taskFeedbackPatient.map((item, index) => (
                              <TableRow
                                id="tableRowTest"
                                key={index}
                                className={
                                  index % 2 === 0 ? "" : this.props.classes.tableBody
                                }
                              >
                                <TableCell
                                  scope="row"
                                  className={this.props.classes.tableCell2}
                                >
                                  {index + 1}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className={this.props.classes.tableCell2}
                                >
                                  {this.formatDate(new Date(item.attributes.created_at), 'en-US')}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className={this.props.classes.tableCell2}
                                >
                                  {this.showRating(item.attributes.rating)}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ "maxWidth": '100px' }}

                                  className={this.props.classes.tableCell2}
                                >
                                  <Typography variant="body2" style={{ maxWidth: '250px' }} >
                                    {this.reviewView(item.attributes.comments, index)}
                                    {<span
                                      id="reviewExpand"
                                      onClick={() => this.expandIndexFun(index)}
                                      style={{ cursor: 'pointer', color: '#A046FB' }}
                                    >
                                      {this.reviewExpand(index, item.attributes.comments)}
                                    </span>}
                                  </Typography>

                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>

                        : <Typography id="Nodatafound" className={this.props.classes.Nodatafoundtext}>
                          {this.state.languageSwitch.StudyNotFound}
                        </Typography>}

                    </TableContainer>
                  </BoxView>
                </Grid>
              </BoxView>
            </Grid>
          </Grid>
        )}
      </>
    );
    // Customizable Area End
  }
}
// Customizable Area Start
const styles = () =>
  createStyles({
    studySelectGrp: {
      color: "#000",
      fontfamily: "Inter Tight",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 500,
      cursor: "pointer",
    },
    mainheadertop: {
      padding: 20,
      position: "sticky",
      top: 0,
      left: 0,
      right: 0,
      background: "#FFF",
      borderBottom: "1px solid rgba(161, 161, 161, 0.50)",
      zIndex: 1,
    },
    mainlogo: {
      width: 150,
    },
    headerAvtar: {
      verticalAlign: "middle",
      marginRight: "12px",
    },
    "& .dropdownLogo": {
      verticalAlign: "middle",
      cursor: "pointer",
    },
    userName: {
      color: "#000",
      fontfamily: "Jost",
      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: 500,
    },
    topBox: {
      display: "flex",
      alignItems: "center",
      gap: "20px",
    },
    PatientsText: {
      color: "#A046FB",
      textAlign: "center" as const,
      fontWeight: 600,
      marginLeft: "10px",
    },
    Patients: {
      paddingTop: "40px",
    },
    subPatients: {
      display: "flex",
      justifyContent: "center",
      padding: "22px",
      backgroundColor: "#fff",
      textAlign: "center" as const,
      borderRadius: "0px 20px 20px 0px",
      marginRight: "25px",
    },
    mainPatients: {
      color: "#1F3650",
      fontFamily: "Jost",
      fontSize: "40px",
      fontWeight: 700,
    },
    subGrid: {
      margin: "40px",
    },
    subText: {
      color: "#414141",
      fontFamily: "Jost",
      fontSize: "14px",
      width: "80%"
    },
    listItemone: {
      backgroundColor: "#A046FB",
      // marginTop: "30px",
      width: "100%",
      height: "200px",
      borderRadius: "8px",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    listbox: {
      padding: "0",
      textAlign: "center",
    },
    total: {
      fontFamily: "Jost",
      fontSize: "32px",
      fontWeight: 700,
    },
    totalPatients: {
      fontFamily: "Jost",
      fontSize: "18px",
    },
    totalPatientsDes: {
      fontFamily: "Jost",
      fontSize: "14px",
      marginTop: '1%'
    },
    listitem: {
      display: "flex",
      flexDirection: "column",
      marginTop: "40px",
    },
    listItemBoxWrap: {
      display: "flex",
    },
    chartBoxWrap: {
      display: "flex",
      marginTop: "26px",
      maxWidth: "900px",
      "@media (max-width: 768px)": {
        display: "block",
      },
    },
    chartBox: {
      height: "484px",
      width: "100%",
      borderRadius: "8px",
      border: "1px solid #EFEFEF",
    },
    chartTaskBox: {
      height: "484px",
      width: '100%',
      borderRadius: "8px",
      border: "1px solid #EFEFEF",
      display: "flex",
      justifyContent: "center", // Centers vertically
      alignItems: "center",
      color: "#292929",
      fontFamily: "Jost",
      fontSize: "15px",
      fontStyle: "normal",
      fontWeight: 600,
    },
    chartTextWrap: {
      width: "100%",
    },
    chartText: {
      color: "#292929",
      fontFamily: "Jost",
      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: 600,
      marginBottom: "20px",
    },
    listItemtwo: {
      backgroundColor: "#F0F0F0",
      // marginTop: "30px",
      width: "100%",
      height: "200px",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    listItemthree: {
      backgroundColor: "#F0F0F0",
      // marginTop: "30px",
      width: "100%",
      height: "200px",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    reports: {
      color: "#A046FB",
      fontFamily: "Jost",
      fontSize: "14px",
      fontWeight: 500,
      border: "none",
    },
    table: {
      maxWidth: "900px",
      boxShadow: "none",
    },
    tableRow: {
      borderRadius: "8px",
      background: "#EFEFEF",
    },
    tableCell: {
      color: "#182221",
      fontFamily: "Jost",
      fontSize: "14px",
      fontWeight: 700,
    },
    tableCell2: {
      border: "none",
      color: "#202423",
      fontFamily: "Jost",
      fontSize: "14px",
      height: "75px",
    },
    tableBody: {
      backgroundColor: "#F0F0F0",
    },
    Nodatafoundtext: {
      color: "#292929",
      fontFamily: "Jost",
      fontSize: "15px",
      fontStyle: "normal",
      fontWeight: 600,
      marginBottom: "20px",
      margin: "12px"
    },
    chartTextCircular: {
      color: "#292929",
      fontFamily: "Jost",
      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: 600,
      marginBottom: "20px"
    },
    chartBoxBar: {
      height: "484px",
      width: "100%",
      borderRadius: "8px",
      border: "1px solid #EFEFEF",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    chartBoxCicular: {
      height: "484px",
      width: "100%",
      borderRadius: "8px",
      border: "1px solid #EFEFEF"
    },
    chartTextWrapCircle: {
      width: "100%",
    },
  });
export default withStyles(styles)(LandingPageBlock);
// Customizable Area End
